<template>
    <div class="container">
        <h1>
            Používatelia
            <router-link
                :to="{ name: 'createUser' }"
                class="btn btn-outline-primary btn-sm"
            >
                <font-awesome-icon :icon="['fas', 'user-plus']" /> Nový
                používateľ
            </router-link>
        </h1>

        <v-data-table
            :headers="headers"
            :items="users"
            :items-per-page="20"
            class="elevation-1"
            loading
            loading-text="Načítavam..."
        >
            <template v-slot:item.action="{ item }">
                <router-link
                    :to="{ name: 'editUser', params: { id: item.id } }"
                    class="btn btn-outline-primary btn-sm"
                    title="Editovať používateľa"
                >
                    <font-awesome-icon :icon="['fas', 'edit']" />
                </router-link>
                <button
                    v-on:click="deleteUser(item.id)"
                    class="btn btn-outline-danger btn-sm"
                >
                    <font-awesome-icon :icon="['fas', 'trash']" />
                </button>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import api from "../../../store/api";

export default {
    name: "Administration",
    data() {
        return {
            headers: [
                { text: "Meno", value: "name" },
                { text: "Email", value: "email" },
                { text: "", value: "action", sortable: false }
            ],
            users: []
        };
    },
    methods: {
        deleteUser: function(id) {
            api.delete(`/users/${id}`)
                .then(response => {
                    this.users = response.data;
                })
                .catch(error => {
                    alert(error);
                });
        }
    },
    mounted() {
        api.get(`/users`)
            .then(response => {
                this.users = response.data;
            })
            .catch(error => {
                alert(error);
            });
    }
};
</script>

<style scoped></style>
